import { DayOfWeek } from "@/utils/dates";

export type TimeReportCalendarCellBackground = "none" | "n25" | "n100" | "g50";

export type GetCellBackgroundArgs = {
  dayIndex: DayOfWeek;
  isInTimeReportingPeriod: boolean;
};

export const getTimeReportCalendarCellBackground = (args: GetCellBackgroundArgs): TimeReportCalendarCellBackground => {
  const isWeekend = args.dayIndex === DayOfWeek.SATURDAY || args.dayIndex === DayOfWeek.SUNDAY;
  return !args.isInTimeReportingPeriod ? "n100" : isWeekend ? "n25" : "none";
};
